import pino from "pino";

export const logger = pino({
  // "info" is the default level. It's specified here for visibility.
  level: "info",
  // disable browser logging to discourage use on the client
  enabled: typeof window === "undefined",
  formatters: {
    level: (level) => ({ level }),
  },
  redact: ["err.config.headers.Authorization"],
});
